import * as React from "react";
// Contexts
import { AppInstanceContext } from "../../../contexts/AppInstanceContext";
// Components
import { Callout as FabricCallout } from "@fluentui/react";
// Utilities
import { css } from "@fluentui/utilities/lib/css";
/**
 * Callout control that customizes the fabric control to our own purposes
 */ export function Callout(props) {
    // Get the app instance context
    const context = React.useContext(AppInstanceContext);
    // Get the bounds for the callout, default to the app bounds if app root id is provided through context
    const bounds = props.bounds ?? document.getElementById(context.appRootElementId)?.getBoundingClientRect();
    // Inject our custom classname
    const { children, ...passThroughProps } = props;
    passThroughProps.className = css("plannerAppCallout", props.className);
    passThroughProps.bounds = bounds;
    return /*#__PURE__*/ React.createElement(FabricCallout, passThroughProps, children);
}
